import { useState } from "react";
import Header from "@/components/Header";
import Sidebar from "@/components/Sidebar";
import Footer from "@/components/Footer";
import LoginMobile from "@/components/LoginMobile";
import FixedMobileMenu from "@/components/FixedMobileMenu";
// Modales globales de autenticación
import { useModalsContext } from "@/contexts/ModalsContext";
import Modal from "@/components/Modals/Modal";
import SignIn from "@/components/Forms/SignIn";
import Register from "@/components/Forms/Register";

export default function MainLayout({ children }) {
  const { modals, openModal, closeModal } = useModalsContext();
  const [sidebarOpen, setSidebarOpen] = useState(
    window.innerWidth >= 640 ? true : false,
  ); // Open sidebar on larger screens

  return (
    <div id="main-layout">
      <Header onSidebarToggle={() => setSidebarOpen((open) => !open)} />
      <main className="relative flex flex-row items-center justify-center h-full sm:h-[var(--main-height)]">
        {/* <div className="sm:hidden absolute top-1/3 right-0 z-50">
          <LoginMobile />
        </div> */}
        <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />
        <div
          id="main-content"
          className={`flex-1 h-full ${
            window.innerWidth <= 640
              ? sidebarOpen
                ? "overflow-hidden "
                : "overflow-y-auto"
              : "overflow-y-auto"
          } bg-aw-bgbluedark-30 scrollbar-box`}
        >
          <div>
            <div
              className={`relative flex flex-col items-center justify-center min-h-[var(--main-height)] p-2 duration-300 transition-all`}
            >
              <div
                className={`sm:hidden ${
                  sidebarOpen
                    ? "bg-black block opacity-30 w-full min-h-[var(--main-height)] absolute top-0 left-0 z-50"
                    : "hidden"
                }`}
                onClick={() => setSidebarOpen(!sidebarOpen)}
              ></div>
              {children}
            </div>
            <Footer />
          </div>
        </div>
      </main>
      <FixedMobileMenu />

      {/* Global Auth Modals */}
      <Modal
        isOpen={modals.signIn}
        onClose={() => closeModal("signIn")}
        large="max-w-4xl"
      >
        <SignIn
          onRegisterClick={() => {
            closeModal("signIn");
            setTimeout(() => openModal("register"), 300);
          }}
        />
      </Modal>
      <Modal
        isOpen={modals.register}
        onClose={() => closeModal("register")}
        large="max-w-4xl"
      >
        <Register
          onBackToSignInClick={() => {
            openModal("signIn");
            setTimeout(() => closeModal("register"), 300);
          }}
        />
      </Modal>
    </div>
  );
}
